/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 26/04/2022
 */

import * as React from 'react';
import { Text as PDFText, StyleSheet } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';

type TextProps = React.ComponentProps<typeof PDFText> & {
    style?: Style | Style[];
};

const Text = ({ style = {}, ...props }: TextProps) => (
    <PDFText style={[styles.text, ...(Array.isArray(style) ? style : [style])]} {...props} />
);

const styles = StyleSheet.create({
    text: {
        fontSize: 11,
        fontFamily: 'Akademie',
        fontWeight: 400,
    },
});

export default Text;
